import { render, staticRenderFns } from "./ReviewItemBuilder.vue?vue&type=template&id=7c643b98&scoped=true"
import script from "./ReviewItemBuilder.vue?vue&type=script&lang=ts"
export * from "./ReviewItemBuilder.vue?vue&type=script&lang=ts"
import style0 from "./ReviewItemBuilder.vue?vue&type=style&index=0&id=7c643b98&prod&lang=scss&scoped=true"
import style1 from "./ReviewItemBuilder.vue?vue&type=style&index=1&id=7c643b98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c643b98",
  null
  
)

export default component.exports